import { useState } from 'react';
import axios from 'axios';
import { useToast } from '../../../../contexts/ToastContext';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const useDgcaBaselineHandlers = (baseline, setBaseline, aircraftType, fetchBaseline, fetchHistory) => {
  const { showToast } = useToast();
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');
  const [resetDialogOpen, setResetDialogOpen] = useState(false);

  const handleChange = (field, value) => {
    setBaseline(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setSuccess('');

      const token = localStorage.getItem('token');
      await axios.put(`${API_URL}/ops/crew-duty-roster/dgca-profile/baseline/config`, {
        ...baseline,
        aircraftType
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSuccess(`Baseline configuration for ${aircraftType} saved successfully!`);
      showToast(`Baseline configuration for ${aircraftType} saved successfully`, 'success');
      await fetchBaseline();
      await fetchHistory();
    } catch (error) {
      console.error('Error saving baseline configuration:', error);
      const errorMessage = error.response?.data?.message || 'Failed to save baseline configuration. Please try again.';
      showToast(errorMessage, 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleReset = async () => {
    try {
      setSaving(true);
      setSuccess('');

      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/ops/crew-duty-roster/dgca-profile/baseline/config?aircraftType=${encodeURIComponent(aircraftType)}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSuccess(`Baseline configuration for ${aircraftType} reset to defaults!`);
      showToast(`Baseline configuration for ${aircraftType} reset to defaults`, 'success');
      setResetDialogOpen(false);
      await fetchBaseline();
      await fetchHistory();
    } catch (error) {
      console.error('Error resetting baseline configuration:', error);
      const errorMessage = error.response?.data?.message || 'Failed to reset baseline configuration. Please try again.';
      showToast(errorMessage, 'error');
    } finally {
      setSaving(false);
    }
  };

  return {
    saving,
    success,
    setSuccess,
    resetDialogOpen,
    setResetDialogOpen,
    handleChange,
    handleSave,
    handleReset
  };
};
